// config.js
export const USE_LOCAL_DATA = process.env.REACT_APP_USE_LOCAL_DATA === 'true';
export const API_URL = process.env.REACT_APP_API_URL;
